export const CONVERSATION_ASSIGNEE_SCOPES = Object.freeze({
  MINE: 'me',
  UNASSIGNED: 'unassigned',
  ALL: 'all',
});

export const resolveConversationAssigneeScope = (
  requestedScope,
  availableScopes
) => {
  const requested = String(requestedScope || CONVERSATION_ASSIGNEE_SCOPES.MINE);
  return availableScopes.includes(requested)
    ? requested
    : availableScopes[0] || CONVERSATION_ASSIGNEE_SCOPES.MINE;
};
